export class TypeLedger {
}
//# sourceMappingURL=typeLedger.js.map